(() => {
  const source = document.currentScript?.src;
  if (!source) return;

  const base = new URL(source);
  const load = (filename, marker, onload) => {
    const existing = document.querySelector(`script[${marker}]`);
    if (existing) {
      onload?.();
      return;
    }

    const url = new URL(base);
    url.pathname = url.pathname.replace(/product-info\.js$/, filename);
    const script = document.createElement('script');
    script.src = url.toString();
    script.async = false;
    script.setAttribute(marker, 'true');
    if (onload) script.addEventListener('load', onload, { once: true });
    document.head.appendChild(script);
  };

  load('product-info-core.js', 'data-ohvora-product-info-core', () => {
    load('ohvora-storefront-fixes.js', 'data-ohvora-storefront-fixes');
  });
})();
